import React from 'react';
import PropTypes from 'prop-types';

import {
	Container,
} from './styles';

import BackgroundColor from '../../common/BackgroundColor';

const Settings = props => {
	return (
		<Container>
			<BackgroundColor
				color={props.options['background-color']}
				updateSettingsHandler={props.updateSettingsHandler}
			/>
		</Container>
	)
}

Settings.propTypes = {
	t: PropTypes.func,
	options: PropTypes.object,
	updateSettingsHandler: PropTypes.func,
}

export default Settings;
